<template>
  <v-card flat color="transparent" class="bookmark-item--list">
    <div class="d-flex align-start">
      <!-- <v-img
        :src="bookmark.faviconUrl"
        :aspect-ratio="1" :width="$vuetify.breakpoint.mdAndUp ? 32 : 24"
        class="neutral50 flex-grow-0 rounded"
      /> -->
      <BulkSelectCheckbox
        v-if="isBulkActionsActive"
        class="mx-3 mt-0"
        :checked="isSelected"
        @click="toggleSelect"
      />
      <!-- FIXME v-img cannot be empty or it flickers/re-renders component weirdly -->
      <!-- probably move away from v-img entirely for anything inside virtual scroller views cuz of inters. obser. -->
      <!-- Can just style the v-responsive div with background-url and size cover -->
      <v-img
        :src="bookmark.faviconUrl" :aspect-ratio="1" :width="display.mdAndUp.value ? 32 : 24"
        class="flex-grow-0 rounded" contain
        :class="bookmark.hasFavicon ? 'neutral25' : bookmark.colorClasses"
      />

      <div class="card-content flex-grow-1 of-hidden px-4">
        <div class="text-neutral400 d-flex align-center mb-2 mt-md-1 text-caption text-md-body-2">
          <BookmarkSource :bookmark="bookmark" no-icon />
          <span class="mx-1">&middot;</span>
          <BookmarkDate :value="bookmark.createdAt" />
        </div>

        <a
          :href="bookmark.brandedUrl" target="_blank" rel="noopener"
          class="text-neutral900" :title="bookmark.title"
          @click="onLinkClick"
        >
          <h4
            class="bookmark-headline text-body-1 mb-1 font-weight-semibold"
          >
            <v-progress-circular
              v-if="bookmark.isLoading && !bookmark.hasSufficientData"
              indeterminate size="16" color="blue400" width="3"
              class="mr-2"
            />
            <span v-text="bookmark.title ?? bookmark.domain" />
          </h4>

          <p
            v-if="bookmark.description"
            class="bookmark-description text-body-2 text-neutral600 mb-3"
            v-text="bookmark.description"
          />
        </a>

        <BookmarkTags v-if="bookmark.tags.length" class="mb-3" :tags="bookmark.tags" @tag-selected="onTagSelected" />

        <BookmarkActions
          :bookmark="bookmark" :user-id="userId"
          :public-mode="publicMode"
          :membership="membership"
          class="text-text"
          @favorite="$emit('favorite')"
          @save="$emit('save')"
          @add-to-collection="$emit('add-to-collection')"
          @add-to-collection-from-collection="$emit('add-to-collection-from-collection')"
          @comments="$emit('comments')"
          @like="$emit('like')"
          @likes="$emit('likes')"
          @more="$emit('more')"
          @pin-edit="$emit('pin-edit')"
        />
      </div>
    </div>
  </v-card>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue'
import { useDisplay } from 'vuetify'
import BookmarkSource from './BookmarkSource'
import BookmarkActions from './BookmarkActions'
import BookmarkDate from './BookmarkDate'
import BookmarkTags from './BookmarkTags'
import { useBulkActionsV2 } from '@/composables/useBulkActionsV2'
import BulkSelectCheckbox from '@/components/BulkSelectCheckbox.vue'


const props = defineProps({
  // Accepts both Bookmark and CollectionItem (when resourceType is 'bookmark')
  bookmark: {
    type: Object,
    required: true,
  },
  userId: {
    type: String,
    default: null,
  },
  membership: {
    type: Object,
    default: null,
  },
  publicMode: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits([
  'toggle-select',
  'tag-selected',
  'favorite',
  'save',
  'add-to-collection',
  'add-to-collection-from-collection',
  'comments',
  'like',
  'likes',
  'more',
  'pin-edit',
])

const display = useDisplay()
const { isBulkActionsActive, isItemSelected } = useBulkActionsV2()

const isSelected = computed(() => {
  return isItemSelected(props.bookmark.id)
})

function onLinkClick(event) {
  if (isBulkActionsActive.value) {
    event.preventDefault()
    toggleSelect()
  }
}

function toggleSelect() {
  emit('toggle-select', props.bookmark)
}

function onTagSelected(tag) {
  emit('tag-selected', tag)
}
</script>

<style lang="scss" scoped>
.bookmark-headline {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  overflow: hidden;
}

.bookmark-description {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  overflow: hidden;
}
</style>
